import React, { useEffect } from 'react';

import { getSessionStorageItem, setSessionStorageItem } from '@revenuemarket/browser';
import { Button } from '@revenuemarket/cds';
import { useCreateConversation } from '~hooks/prompt/useCreateConversation';

interface ConversationManagerProps {
  companyId?: string;
  isOpen: boolean;
  conversationId: string | undefined;
  onConversationChange: (id: string) => void;
}

export default function ConversationManager({
  companyId,
  isOpen,
  conversationId,
  onConversationChange,
}: ConversationManagerProps) {
  const { mutateAsync: createConversation, isLoading: isCreatingNewConversation } =
    useCreateConversation();

  // localStorage에서 대화 ID 가져오기
  const getStoredConversationId = () => {
    return getSessionStorageItem<string>('aiChatConversationId');
  };

  // localStorage에 대화 ID 저장하기
  const setStoredConversationId = (id: string) => {
    setSessionStorageItem('aiChatConversationId', id);
  };

  // 새로운 대화 생성
  const createNewConversation = async () => {
    try {
      const response = await createConversation();
      const newConversationId = response.Data?.data?.conversationId;
      if (newConversationId !== undefined) {
        onConversationChange(newConversationId);
        setStoredConversationId(newConversationId);
      }
    } catch (error) {
      console.error('대화 생성 실패:', error);
    }
  };

  // 사이드바가 열릴 때 대화 ID 확인 및 생성
  useEffect(() => {
    (async () => {
      if (isOpen && companyId) {
        // 먼저 localStorage에서 기존 대화 ID 확인
        const storedId = getStoredConversationId();

        if (storedId && !conversationId) {
          // 저장된 대화 ID가 있고 현재 conversationId가 없으면 설정
          onConversationChange(storedId);
        } else if (!storedId && !conversationId) {
          // 저장된 대화 ID도 없고 현재 conversationId도 없으면 새로 생성
          await createNewConversation();
        }
      }
    })();
  }, [isOpen, companyId, conversationId]);

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <Button
        buttonType="default"
        onClick={createNewConversation}
        disabled={isCreatingNewConversation}
        style={{ padding: '4px 8px', minWidth: 'auto' }}
      >
        새 대화
      </Button>
    </div>
  );
}
